/*
* @author 友人a丶
* @date 2022-07-11
* 系统运行时静态配置
* */

// 解析URL参数
function getUrlParams() {
    const params = {};
    const queryString = window.location.hash.split('?')[1];
    if (queryString) {
        queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        });
    }
    return params;
}

const urlParams = getUrlParams();

export default {
    inited_Plus: false, //Plus对象是否已经初始化
    inited_APP: false, //是否已经初始化应用
    init_height: window.innerHeight, //初始化高度
    init_loaded: false, //系统是否已经初始化
    debug: urlParams.mock === 'true' || true, //是否开启调试模式（mock=true时强制开启）
    detect_network: true, //是否检测网络
    detect_overlay: false, //是否检测后台弹出权限
    isMockMode: urlParams.mock === 'true' //是否为模拟数据模式
};